import { colors } from '@/utils';

export const Disconnected = () => {
  return (
    <svg
      fill={`${colors.icon.alarm[100]}`}
      width='18px'
      height='18px'
      viewBox='0 0 1024.00 1024.00'
      xmlns='http://www.w3.org/2000/svg'
      className='icon'
      transform='matrix(1, 0, 0, 1, 0, 0)'
      stroke='#000000'
      strokeWidth='0.01024'
    >
      <g id='SVGRepo_bgCarrier' strokeWidth='0'></g>
      <g
        id='SVGRepo_tracerCarrier'
        strokeLinecap='round'
        strokeLinejoin='round'
        stroke='#CCCCCC'
        strokeWidth='12.288'
      ></g>
      <g id='SVGRepo_iconCarrier'>
        <path d='M832.6 191.4c-84.6-84.6-221.5-84.6-306 0l-96.9 96.9 51 51 96.9-96.9c53.8-53.8 144.6-59.5 204 0 59.5 59.5 53.8 150.2 0 204l-96.9 96.9 51.1 51.1 96.9-96.9c84.4-84.6 84.4-221.5-.1-306.1zM446.5 781.6c-53.8 53.8-144.6 59.5-204 0-59.5-59.5-53.8-150.2 0-204l96.9-96.9-51.1-51.1-96.9 96.9c-84.6 84.6-84.6 221.5 0 306s221.5 84.6 306 0l96.9-96.9-51-51-96.8 97zM260.3 209.4a8.03 8.03 0 0 0-11.3 0L209.4 249a8.03 8.03 0 0 0 0 11.3l554.4 554.4c3.1 3.1 8.2 3.1 11.3 0l39.6-39.6c3.1-3.1 3.1-8.2 0-11.3L260.3 209.4z'></path>
      </g>
    </svg>
  );
};
